module.exports = __webpack_public_path__ + "img/82.d164c716.jpg";